export default __webpack_public_path__ + "static/media/bbb.0e4cf24c.png";